<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/restaurant/topic_icon.svg" />
      <h1>Dining <br class="mo_show" />Establishments</h1>
      <p>
        Meticulous hygiene management ensures
        <br />
        customers can dine with assurance.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Restaurants </span>
        <span class="tag"> #cafes </span>
        <span class="tag"> #Virtual restaurants </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/restaurant/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Dining Establishments"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_pests.svg" alt="CESCO [BusinessSectors] Dining Establishments" />
            <div class="title">
              <h3>Professional Hygiene Management</h3>
            </div>
            <p class="description">I seek systematic pest and hygiene management.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_speaker.svg" alt="CESCO [BusinessSectors] Dining Establishments" />
            <div class="title">
              <h3>Promotion Across Various Channels</h3>
            </div>
            <p class="description">I want my restaurant to be recognized as a clean establishment that everyone can trust and choose.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>Present your dining establishment as a space that proactively secures against pests.</h4>
            <p>
              By blocking pest entry, we prevent potential exposure to customers dining in and avoid contamination in the cooking facilities and
              delivered food.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/restaurant/border_content_01.png" alt="CESCO [BusinessSectors] Dining Establishments" />
          </div>
          <div>
            <img src="@/assets/images/location/restaurant/border_content_02.png" alt="CESCO [BusinessSectors] Dining Establishments" />
          </div>
          <div class="border-content">
            <h4>Achieving recognition as a hygiene-certified establishment on delivery apps enhances trust among customers.</h4>
            <p>For businesses, we offer a certification mark to help customers recognize the space as pest-free and hygienic.</p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>
        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Dining Establishments" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Dining Establishments" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Dining Establishments
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Dining Establishments" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_food.svg" alt="CESCO [BusinessSectors] Dining Establishments" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Food Safety
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Systematic diagnostics and solutions for food safety</p>
            </div>

            <router-link to="/solution/service/food"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Dining Establishments" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_01.png'),
    products: [
      {
        posX: '36.375rem',
        posY: '30.0287rem',
        mobilePosX: '47%',
        mobilePosY: '79%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_01.png'),
          name: 'CESCO \n' + 'Smart Indoor Rodent Control Equipment Viper',
          description: 'Hygienically captures rats that enter business premises and monitors their movement and habitation with smart technology.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_02.png'),
    products: [
      {
        posX: '10.4375rem',
        posY: '7.4037rem',
        mobilePosX: '15%',
        mobilePosY: '22%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_02.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_03.png'),
    products: [
      {
        posX: '53.625rem',
        posY: '16.9662rem',
        mobilePosX: '73%',
        mobilePosY: '46%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_03.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Hand Gienic',
          description: 'This non-contact foam type eliminates 99.9% of harmful bacteria on hands.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_04.png'),
    products: [
      {
        posX: '19.4375rem',
        posY: '7.4037rem',
        mobilePosX: '25%',
        mobilePosY: '22%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_04.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'Destroys viruses directly in the air with the Virus Pre-attack System<sup>TM</sup>. *Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_05.png'),
    products: [
      {
        posX: '35.3125rem',
        posY: '20.9037rem',
        mobilePosX: '43%',
        mobilePosY: '62%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_04.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'Destroys viruses directly in the air with the Virus Pre-attack System<sup>TM</sup>. *Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_06.png'),
    products: [
      {
        posX: '54.1875rem',
        posY: '17.5287rem',
        mobilePosX: '77.5%',
        mobilePosY: '47%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_05.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_07.png'),
    products: [
      {
        posX: '41.125rem',
        posY: '24.0912rem',
        mobilePosX: '55%',
        mobilePosY: '75%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_06.png'),
          name: 'CESCO\nAir Smart-Fit\nAir Purifier',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_08.png'),
    products: [
      {
        posX: '42.5625rem',
        posY: '25.8412rem',
        mobilePosX: '56%',
        mobilePosY: '75%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_07.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      },
      {
        posX: '55.6875rem',
        posY: '9.9663rem',
        mobilePosX: '73.5%',
        mobilePosY: '28%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_08.png'),
          name: 'CESCO\nIndoor Insect Light Inceptor',
          description: 'This device controls stray pests entering business premises and also serves an aesthetic function with its compact design.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/restaurant/background_img_09.png'),
    products: [
      {
        posX: '20.25rem',
        posY: '18.7787rem',
        mobilePosX: '28%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/restaurant/product_img_09.png'),
          name: 'CESCO\nSpace Fragrancer Airperfume',
          description: 'This product uniformly scents large spaces with fragrances designed specifically for various types of businesses.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Dining Establishments',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Dining Establishments. Meticulous hygiene management ensures customers can dine with assurance.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
